<script>
  const logo_x = "/assets_default/icons/sns/logo_x.svg"
  const logo_facebook = "/assets_default/icons/sns/logo_facebook.svg"
  const logo_instagram = "/assets_default/icons/sns/logo_instagram.svg"
  const logo_youtube = "/assets_default/icons/sns/logo_youtube.svg"
  const logo_note = "/assets_default/icons/sns/logo_note.svg"
  const img_bubble = "/assets_default/images/common/bubble-white.svg"
  const sns = [
    {
      path: logo_x,
      alt: "Xアイコン",
      link: "https://x.com/minnano_ginko"
    },
    {
      path: logo_facebook,
      alt: "facebookアイコン",
      link: "https://www.facebook.com/minnanoginko"
    },
    {
      path: logo_instagram,
      alt: "instagramアイコン",
      link: "https://www.instagram.com/minnano_ginko_official/"
    },
    {
      path: logo_youtube,
      alt: "youtubeアイコン",
      link: "https://www.youtube.com/@minnano_ginko"
    },
    {
      path: logo_note,
      alt: "noteアイコン",
      link: "https://note.minna-no-ginko.com/"
    },
  ]
</script>

<div class="owd-sns-contents:inner">
  <div class="owd-sns-contents:comment spacing:bottom:24">
    <!-- img差し替え予定 -->
    <img src="{img_bubble}" alt="吹き出し">
    <!-- <p class="owd-text:01 owd-en bubble-comment"><strong>SNS</strong></p> -->
  </div>
  <ul class="spacing:bottom:24">
    {#each sns as i}
    <li>
      <a href="{i.link}" target="_blank">
        <img src="{i.path}" alt="{i.alt}">
      </a>
    </li>
    {/each}
  </ul>
  <p class="owd-text:02">ハッシュタグ「＃みんなでつくるみんなの銀行」を付けて投稿してください。​</p>
</div>

<style lang="scss">
  .owd-sns-contents{
    &\:inner{
      width: 100%;
      padding:24px;
      ul{
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 16px;
      }
    }
    &\:comment{
      position: relative;
      display: flex;
      justify-content: center;
      img{
        width: 141px;
      }
      .bubble-comment{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
      }
    }
  }
</style>
